import type {SagaIterator} from 'redux-saga';
import {put, takeEvery, select} from 'redux-saga/effects';

import {changeItemQtyAction} from '../../reducers/changeItemQty/changeItemQty';
import {clearPlaceOfInteraction} from '../../reducers/placeOfInteraction/placeOfInteraction';
import {getQuote} from '../../reducers/quoteItems/quoteItems';
import {getPlaceOfInteraction} from '../../selectors/placeOfInteraction/placeOfInteraction';

/**
 * clear place of interaction if it exist
 */
export function* clearInteraction(): SagaIterator {
    const placeOfInteraction = yield select(getPlaceOfInteraction);
    if (!placeOfInteraction) return false;
    return yield put(clearPlaceOfInteraction());
}

/**
 * placeOfInteractionSaga
 */
export default function* placeOfInteractionSaga(): SagaIterator {
    yield takeEvery(
        [`${changeItemQtyAction.fulfilled}`, `${getQuote.fulfilled}`],
        clearInteraction,
    );
}
